import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import InputGroup from '../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../util/assets';
import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.shape({
    password: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  isFormValid: PropTypes.bool,
  onEmailPinRequest: PropTypes.func.isRequired,
};

const AuthModeEmailPassword = ({
  onSubmit,
  values,
  onChange,
  error,
  loading,
  isFormValid,
  onEmailPinRequest,
}) => {
  return (
    <Fragment>
      <form className="login-form" onSubmit={onSubmit}>
        <InputGroup
          id="password"
          type="password"
          name="password"
          autoFocus
          addon={
            <img alt="" src={getAsset('/shutterbug/icons/password.svg')} />
          }
          placeholder="Password"
          value={values.password}
          onChange={({ target }) => onChange('password', target.value)}
          wrapperClassName="mb-1"
        />
        <div className="d-flex align-items-center justify-content-center justify-content-between text-sm">
          <Button
            btnStyle="link"
            btnSize="sm"
            onClick={() => onEmailPinRequest()}
          >
            Request a pin code
          </Button>
          <Link to="/auth/password/reset">Forgot your password?</Link>
        </div>

        {error && (
          <Alert type="danger" className="mt-2">
            <strong>Signing in wasn&apos;t successful</strong>
            <br />
            {error}
          </Alert>
        )}
        <div className="text-center">
          <Button
            type="submit"
            className="mt-4 mb-1 login-email-form-button"
            disabled={loading || !isFormValid}
            data-testId="sign-in-button"
          >
            {!loading ? 'Log in' : <Spinner light size="xs" />}
          </Button>
        </div>
      </form>
    </Fragment>
  );
};

AuthModeEmailPassword.propTypes = propTypes;

export default AuthModeEmailPassword;
